import type { PillarId, Route, WorldEntryId } from "../types";

const pillarIds = new Set<PillarId>(["reliability", "product", "leverage"]);

export function normalizeHash(hash: string): string {
  const withoutHash = hash.replace(/^#/, "");
  if (!withoutHash || withoutHash === "/") {
    return "/";
  }
  return withoutHash.startsWith("/") ? withoutHash : `/${withoutHash}`;
}

export function parseHashRoute(hash: string): Route {
  const path = normalizeHash(hash);

  if (path === "/workflow") return { kind: "workflow" };
  if (path === "/about") return { kind: "about" };
  if (path === "/index") return { kind: "index" };
  if (path === "/read") return { kind: "read" };
  if (path === "/contact") return { kind: "contact" };

  const pillarPrefix = path.startsWith("/pillar/")
    ? "/pillar/"
    : path.startsWith("/work/")
      ? "/work/"
      : null;
  if (pillarPrefix) {
    const slug = path.slice(pillarPrefix.length) as PillarId;
    if (pillarIds.has(slug)) return { kind: "pillar", slug };
  }

  return { kind: "home" };
}

export function routeToWorldEntry(route: Route): WorldEntryId | null {
  if (route.kind === "workflow" || route.kind === "about") return route.kind;
  if (route.kind === "pillar") return route.slug;
  return null;
}

export function navigate(path: string): void {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (window.location.hash === `#${normalized}`) return;
  window.location.hash = normalized;
}
